var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"is-flex"},[(_vm.isLoggedIn === false)?_c('div',{staticClass:"has-text-white"},[_c('span',{staticClass:"mdi mdi-alert"}),_vm._v("\n    "+_vm._s(_vm.$t('common.unlogged'))+"\n    "),_c('span',{staticClass:"mdi mdi-alert"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cde0b00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoggedInDisplayer.vue
// module id = null
// module chunks = 